import React from 'react';
import Reveal from '../components/Reveal';

const sections = [
  {
    title: '1. Informações Gerais',
    paragraphs: [
      'A Arco Tech Sistemas está comprometida em proteger a privacidade e os dados pessoais de nossos usuários. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações quando você utiliza nossos serviços de etiquetagem e gestío de estoque.'
    ]
  },
  {
    title: '2. Informações que Coletamos',
    paragraphs: ['Coletamos as seguintes categorias de informações:'],
    list: [
      'Informações de identificação pessoal (nome, e-mail, telefone)',
      'Dados da empresa (razío social, CNPJ, endereço)',
      'Informações de uso do sistema (logs de acesso, funcionalidades utilizadas)',
      'Dados de produtos e estoque inseridos no sistema',
      'Informações de pagamento (processadas por terceiros seguros)'
    ]
  },
  {
    title: '3. Como Utilizamos suas Informações',
    paragraphs: ['Utilizamos suas informações para:'],
    list: [
      'Fornecer e manter nossos serviços de etiquetagem',
      'Processar transações e gerenciar sua conta',
      'Enviar comunicações importantes sobre o serviço',
      'Melhorar nossos produtos e desenvolver novos recursos',
      'Garantir a segurança e prevenir fraudes',
      'Cumprir obrigações legais e regulamentares'
    ]
  },
  {
    title: '4. Compartilhamento de Informações',
    paragraphs: ['Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros, exceto:'],
    list: [
      'Com seu consentimento explícito',
      'Para cumprir obrigações legais',
      'Com prestadores de serviços que nos auxiliam (sob acordos de confidencialidade)',
      'Em caso de fusío, aquisição ou venda de ativos da empresa'
    ]
  },
  {
    title: '5. Segurança dos Dados',
    paragraphs: ['Implementamos medidas de segurança técnicas e organizacionais apropriadas para proteger suas informações contra acesso não autorizado, alteração, divulgação ou destruição, incluindo:'],
    list: [
      'Criptografia de dados em trânsito e em repouso',
      'Controles de acesso rigorosos',
      'Monitoramento contínuo de segurança',
      'Backups regulares e seguros',
      'Treinamento regular da equipe em segurança da informação'
    ]
  },
  {
    title: '6. Seus Direitos',
    paragraphs: ['De acordo com a LGPD, você tem os seguintes direitos:'],
    list: [
      'Confirmação da existência de tratamento de dados',
      'Acesso aos seus dados pessoais',
      'Correção de dados incompletos, inexatos ou desatualizados',
      'Anonimização, bloqueio ou eliminação de dados desnecessários',
      'Portabilidade dos dados',
      'Eliminação dos dados tratados com consentimento',
      'Revogação do consentimento'
    ]
  },
  {
    title: '7. Retenção de Dados',
    paragraphs: [
      'Mantemos suas informações pessoais apenas pelo tempo necessário para cumprir as finalidades descritas nesta política, atender a requisitos legais ou resolver disputas. Dados de produtos e estoque sío mantidos enquanto sua conta estiver ativa ou conforme necessário para fornecer nossos serviços.'
    ]
  },
  {
    title: '8. Cookies e Tecnologias Similares',
    paragraphs: [
      'Utilizamos cookies e tecnologias similares para melhorar sua experiência, analisar o uso do site e personalizar conteúdo. Você pode gerenciar suas preferências de cookies através das configurações do seu navegador.'
    ]
  },
  {
    title: '9. Alterações nesta Política',
    paragraphs: [
      'Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos sobre mudanças significativas através do e-mail cadastrado ou por meio de aviso em nosso site. A data da última atualização será sempre indicada no topo desta página.'
    ]
  },
  {
    title: '10. Contato',
    paragraphs: [
      'Para exercer seus direitos, esclarecer dúvidas sobre esta política ou reportar preocupações sobre privacidade, entre em contato conosco:'
    ],
    contact: [
      ['E-mail', 'privacidade@etiquetando.com.br'],
      ['Telefone', '(11) 9999-9999'],
      ['Endereço', 'Rua das Etiquetas, 123 - Sío Paulo, SP - CEP: 01234-567']
    ]
  }
];

export default function PrivacyPolicyPage() {
  return (
    <section className="page-section policy-page">
      <div className="container policy-container">
        <Reveal className="page-hero">
          <h1>Política de Privacidade</h1>
          <p>Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
        </Reveal>

        <div className="policy-content">
          {sections.map((section, index) => (
            <Reveal key={section.title} delay={index * 75} className="policy-section">
              <h2>{section.title}</h2>
              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
              {section.list ? (
                <ul>
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ) : null}
              {section.contact ? (
                <div className="policy-contact">
                  {section.contact.map(([label, value]) => (
                    <p key={label}>
                      <strong>{label}:</strong> {value}
                    </p>
                  ))}
                </div>
              ) : null}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
